import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { fetchFile } from "~/store/actions/actions.files";
import { useGlobalPrivateChannelListener } from "../Hooks/useGlobalPrivateChannelListener";

export const FilesRealtime = () => {
  const dispatch = useDispatch();
  const listener = useCallback(
    ({ id = 0, project_id = 0 }) => {
      dispatch(fetchFile(id, project_id));
    },
    [dispatch]
  );

  useGlobalPrivateChannelListener("FileCreated", listener);
  useGlobalPrivateChannelListener("FileUpdated", listener);
  useGlobalPrivateChannelListener("FileMovedToTrash", listener);
  useGlobalPrivateChannelListener("FileRestoredFromTrash", listener);

  return null;
};
